import type * as React from 'react';

import { Button, type ButtonProps } from '../Button';
import { Paper } from '../Paper';
import { Popover, PopoverRoot, PopoverTrigger, usePopoverTriggerState } from '../Popover';
import { EmojiPicker } from './EmojiPicker';

/**
 * Button to pick an emoji.
 */
export function EmojiPickerButton(
    props: {
        /**
         * Callback when an emoji is picked.
         */
        onPick: (emoji: string) => void;
    } & Omit<ButtonProps, 'onPress'>
): React.ReactElement {
    const { onPick, ...rest } = props;

    const popover = usePopoverTriggerState();

    return (
        <PopoverRoot {...popover.rootProps}>
            <PopoverTrigger>
                <Button {...rest} />
            </PopoverTrigger>
            <Popover>
                <Paper>
                    <EmojiPicker
                        onPick={(emoji: string) => {
                            popover.close();
                            onPick(emoji);
                        }}
                    />
                </Paper>
            </Popover>
        </PopoverRoot>
    );
}
